// Mock data for Mind Flex Games corporate website

export const companyInfo = {
  name: "Mind Flex Games, LLC",
  tagline: "Building Skill-Based, Compliance-Driven Digital Gaming Platforms",
  subheading: "US-based gaming company focused on responsible, skill-centric sports gaming experiences.",
  address: {
    street: "1901 Main Street, 18th Floor, #2039",
    city: "Columbia",
    state: "SC",
    zip: "29201",
    country: "USA"
  },
  logos: {
    mindFlex: "https://customer-assets.emergentagent.com/job_fbf437f3-7cc8-48b1-9e52-1fe6efaa9989/artifacts/xyvpvq64_Mind%20Flex%20Inverted%20Color%20800x600.jpg",
    fanDrill: "https://customer-assets-jt897jd0.emergentagent.net/job_66dc536f-548c-44f5-92b4-a77729be88e2/artifacts/ip66zj9d_Logo%20%4016x-8.webp"
  }
};

export const aboutContent = {
  title: "About Mind Flex Games",
  description: "Mind Flex Games is a US-based gaming company dedicated to developing skill-based digital gaming platforms. Our approach centers on compliance, sustainability, and responsible market participation.",
  highlights: [
    {
      title: "US-Based Operations",
      description: "Headquartered in the United States with a focus on regulated markets."
    },
    {
      title: "Skill-Based Focus",
      description: "Developing platforms where outcomes are determined by participant knowledge and expertise."
    },
    {
      title: "Compliance-Driven",
      description: "Built on a foundation of regulatory compliance and responsible business practices."
    },
    {
      title: "Long-Term Vision",
      description: "Committed to sustainable growth and responsible market development."
    }
  ]
};

export const capabilities = [
  {
    id: 1,
    title: "Skill-Based Contest Frameworks",
    description: "Developing structured contest systems where participant skill and knowledge drive outcomes.",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Fantasy Sports Platform Development",
    description: "Building robust, scalable platforms for daily fantasy sports experiences.",
    icon: "Layout"
  },
  {
    id: 3,
    title: "Compliance-Aware Game Design",
    description: "Creating gaming experiences with regulatory compliance integrated from the ground up.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Data & Analytics-Driven Engagement",
    description: "Leveraging data insights to enhance platform functionality and user experience.",
    icon: "BarChart3"
  }
];

export const fanDrillBrand = {
  name: "FanDrill",
  tagline: "Daily Fantasy Sports",
  description: "A Daily Fantasy Sports platform built on Mind Flex Games' skill-based and compliance-first foundation.",
  highlights: [
    "Skill-centric contests designed around participant expertise",
    "Transparency and fairness in all platform operations",
    "Multi-sport expansion vision for comprehensive coverage"
  ]
};

export const technologyFeatures = [
  {
    id: 1,
    title: "Data-Driven Decision Systems",
    description: "Advanced analytics powering informed platform development and optimization.",
    icon: "Database"
  },
  {
    id: 2,
    title: "Fairness & Integrity Controls",
    description: "Robust systems ensuring equitable outcomes and platform integrity.",
    icon: "Scale"
  },
  {
    id: 3,
    title: "Secure & Scalable Infrastructure",
    description: "Enterprise-grade architecture built for security and growth.",
    icon: "Server"
  },
  {
    id: 4,
    title: "Continuous Product Innovation",
    description: "Ongoing development and enhancement of platform capabilities.",
    icon: "Lightbulb"
  }
];

export const compliancePoints = [
  {
    id: 1,
    title: "Permitted Jurisdictions Only",
    description: "Operations conducted exclusively in legally permitted markets.",
    icon: "MapPin"
  },
  {
    id: 2,
    title: "Skill-Based Gaming Principles",
    description: "Platform design centered on skill-determined outcomes.",
    icon: "Award"
  },
  {
    id: 3,
    title: "User Protection Standards",
    description: "Comprehensive measures to protect participant interests.",
    icon: "UserCheck"
  },
  {
    id: 4,
    title: "Age-Restricted Participation",
    description: "Strict verification ensuring only eligible adults participate.",
    icon: "ShieldCheck"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Executive Leadership",
    title: "Chief Executive Officer",
    expertise: "Strategic leadership in fantasy sports and digital gaming operations with extensive industry experience."
  },
  {
    id: 2,
    name: "Operations Leadership",
    title: "Chief Operating Officer",
    expertise: "Gaming operations and platform management with focus on compliance and sustainable growth."
  },
  {
    id: 3,
    name: "Technology Leadership",
    title: "Chief Technology Officer",
    expertise: "Technology architecture and product development for scalable gaming platforms."
  },
  {
    id: 4,
    name: "Compliance Leadership",
    title: "Chief Compliance Officer",
    expertise: "Regulatory compliance and responsible gaming program development and implementation."
  }
];

export const contactCategories = [
  { value: "partnerships", label: "Partnerships" },
  { value: "compliance", label: "Compliance" },
  { value: "general", label: "General Inquiries" },
  { value: "investment", label: "Investment Opportunity" }
];

export const footerLinks = {
  legal: [
    { label: "Privacy Policy", href: "#privacy" },
    { label: "Terms of Service", href: "#terms" },
    { label: "Cookie Policy", href: "#cookies" }
  ]
};

export const images = {
  hero: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3klMjBuZXR3b3JrfGVufDB8fHx8MTc2OTUwNTQyNXww&ixlib=rb-4.1.0&q=85",
  heroBackground: "https://customer-assets.emergentagent.com/job_mindflex-corporate/artifacts/3hqfym1i_ChatGPT%20Image%20Jan%2027%2C%202026%2C%2003_21_02%20PM.png",
  technology: "https://images.unsplash.com/photo-1762279389002-7b6abd7bd6c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3klMjBuZXR3b3JrfGVufDB8fHx8MTc2OTUwNTQyNXww&ixlib=rb-4.1.0&q=85",
  analytics: "https://images.unsplash.com/photo-1762279389083-abf71f22d338?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxkYXRhJTIwYW5hbHl0aWNzJTIwdmlzdWFsaXphdGlvbnxlbnwwfHx8fDE3Njk1MDU0MzF8MA&ixlib=rb-4.1.0&q=85"
};
